<template>
    <div>
        <BaseCard as="section" theme="cream" radius="lgr" class="profile-cta-card" :aria-labelledby="headingId" data-testid="profile-cta-card">
            <h2 :id="headingId" class="headline">{{ t("perspective.collaborationCta.headline") }}</h2>
            <p class="description">{{ t("perspective.collaborationCta.description") }}</p>
            <BaseLink :href="createHref" :before="trackCreate" class="base-btn-primary create-action" data-testid="profile-cta-create">{{
                t("perspective.collaborationCta.create")
            }}</BaseLink>
        </BaseCard>
        <div class="secondary-actions">
            <BaseButton v-if="showRetake" theme="tertiary" size="sm" class="secondary-action" :disabled="isRetaking" @click="emit('retake')">
                <i class="bi bi-arrow-counterclockwise" aria-hidden="true"></i>
                {{ t("perspective.collaborationCta.retake") }}
            </BaseButton>
            <BaseLink :href="chatHref" class="base-btn-tertiary base-btn-sm secondary-action">
                <i class="bi bi-chat" aria-hidden="true"></i>
                {{ t("perspective.collaborationCta.chatWithNadia") }}
            </BaseLink>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import BaseLink from "~vue/router/BaseLink.vue";
import { useId } from "vue";
import { useI18n } from "vue-i18n";

const { createHref, trackCreate, chatHref, showRetake, isRetaking } = defineProps<{
    createHref: string;
    trackCreate: () => Promise<unknown>;
    chatHref: string;
    showRetake: boolean;
    isRetaking: boolean;
}>();
const emit = defineEmits<{ retake: [] }>();

const { t } = useI18n();
const headingId = useId();
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .profile-cta-card {
        @apply flex flex-col gap-4 shadow-elevated;
    }

    .headline {
        @apply title-card-serif text-ink;
    }

    .description {
        @apply body-small text-ink-muted;
    }

    .create-action {
        @apply block w-full text-center;
    }

    .secondary-actions {
        @apply mt-3 flex items-center justify-center;
    }

    .secondary-action {
        @apply inline-flex items-center gap-2;
        --color-button-tertiary-text: var(--color-ink-muted);
    }
}
</style>
